export default __webpack_public_path__ + "static/media/E-commerce-gif3.92825595.gif";